import React, { FC } from 'react'
import { Autocomplete, Grid, TextField, Theme, Typography } from '@mui/material'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { Modal } from '../../../components/Modal'

interface IntroducerUnassignModalProps {
  isOpen: boolean
  modalClose: () => void
  onSubmit: () => void
  idSf: string | undefined
}

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    color: theme.palette.primary.light,
    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.main,
    },
    '& .MuiAutocomplete-endAdornment': {
      '& .MuiIconButton-root': {
        color: theme.palette.primary.light,
      },
    },
  },
  disabled: {
    color: theme.palette.primary.light,
    pointerEvents: 'none',
    '& .MuiOutlinedInput-root': {
      cursor: 'default',
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'none',
    },
  },
}))

export const IntroducerUnassignModal: FC<IntroducerUnassignModalProps> = ({ idSf, isOpen, modalClose, onSubmit }) => {
  const classes = useStyles()
  return (
    <Modal title="Remove User" submitTitle="Confirm" isOpen={isOpen} modalClose={modalClose} onSubmit={onSubmit}>
      <Typography variant="body1" component="div">
        Are you sure you want to remove this introducee from the introducer?
      </Typography>
      <Grid item xs={12} display="flex" flexDirection="row" justifyContent="center" alignItems="center" pt={3}>
        <Grid item xs={4}>
          <Typography variant="h6">Introducer</Typography>
        </Grid>
        <Grid item xs={8}>
          <Autocomplete
            value={idSf}
            disableClearable
            options={idSf ? [idSf] : []}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField {...params} className={clsx(classes.select, classes.disabled)} fullWidth />
            )}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}
